export default __webpack_public_path__ + "static/media/gallery_12.9bf781f2.jpg";